var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#00B600",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.04 0C4.545 0 0 4.468 0 9.96 0 15.455 4.546 20 10.04 20 15.531 20 20 15.454 20 9.96 20 4.469 15.532 0 10.04 0zm1.17 15.313c0 .646-.525 1.171-1.17 1.171-.647 0-1.173-.525-1.173-1.172V9.375c0-.646.526-1.172 1.172-1.172.646 0 1.172.526 1.172 1.172v5.938zm-1.17-9.454c-.647 0-1.173-.525-1.173-1.171 0-.647.526-1.172 1.172-1.172.646 0 1.172.525 1.172 1.171 0 .647-.526 1.172-1.172 1.172z",
    transform: "translate(-96.000000, -3357.000000) translate(80.000000, 3154.000000) translate(0.000000, 187.000000) translate(16.000000, 16.000000) translate(2.000000, 2.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.8b9a5768.svg";
export { ForwardRef as ReactComponent };